// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { IGetFullscreenObject } from './types';

export const getFullscreenObject = (): IGetFullscreenObject => {
  if (
    document.webkitFullscreenEnabled ||
    document.fullscreenEnabled ||
    document.mozFullScreenEnabled ||
    document.msFullscreenEnabled
  ) {
    if (document.webkitFullscreenEnabled)
      return {
        element: 'webkitFullscreenElement',
        change: 'webkitfullscreenchange',
      };
    if (document.mozFullScreenEnabled)
      return { element: 'mozFullScreenElement', change: 'mozfullscreenchange' };
    if (document.msFullscreenEnabled)
      return { element: 'msFullscreenElement', change: 'MSFullscreenChange' };
    return { element: 'fullscreenElement', change: 'fullscreenchange' };
  }

  // throw new Error('O recurso de fullscreen não é suportado.');
  console.error('O recurso de fullscreen não é suportado.');

  return false;
};

export const requestFullscreen = (element: HTMLElement): any => {
  const fullscreenObject = getFullscreenObject();

  if (!fullscreenObject) return false;

  const fullscreenElement = fullscreenObject.element;

  switch (fullscreenElement) {
    case 'webkitFullscreenElement':
      return element.webkitRequestFullscreen ? element.webkitRequestFullscreen() : false;

    case 'mozFullScreenElement':
      return element.mozRequestFullScreen ? element.mozRequestFullScreen() : false;

    case 'msFullscreenElement':
      return element.msRequestFullscreen ? element.msRequestFullscreen() : false;

    case 'fullscreenElement':
    default:
      return element.requestFullscreen ? element.requestFullscreen() : false;
  }
};

export const exitFullscreen = (): Promise<void> => {
  const fullscreenObject = getFullscreenObject();

  if (!fullscreenObject) return false;

  const fullscreenElement = fullscreenObject.element;

  switch (fullscreenElement) {
    case 'webkitFullscreenElement':
      return document.webkitExitFullscreen();

    case 'mozFullScreenElement':
      return document.mozCancelFullScreen();

    case 'msFullscreenElement':
      return document.msExitFullscreen();

    case 'fullscreenElement':
    default:
      return document.exitFullscreen();
  }
};

export const getIsFullscreen = (): boolean => {
  const fullscreenObject = getFullscreenObject();

  if (!fullscreenObject) return false;

  return Boolean(document[fullscreenObject.element]);
};
